import React from "react";
import { getSectionLabel } from "@/utils/exam";

interface ModuleEndPanelProps {
  examType?: string;
}

const ModuleEndPanel: React.FC<ModuleEndPanelProps> = ({ examType }) => {
  return (
    <div className="min-h-screen bg-white flex flex-col justify-center items-center">
      <div className="text-center">
        <h2 className="text-3xl font-semibold text-[#3451d6] mb-6 mt-8">
          This {getSectionLabel(examType)} Is Over
        </h2>
        <div className="text-lg text-gray-700 mb-2">
          All your work has been saved.
        </div>
        <div className="text-lg text-gray-700 mb-2">
          You'll move on automatically in just a moment.
        </div>
        <div className="text-lg text-gray-700 mb-8">
          Do not refresh this page or quit the app.
        </div>
        <div className="flex justify-center mt-8">
          <span className="inline-block w-12 h-12 border-4 border-gray-300 border-t-[#3451d6] rounded-full animate-spin"></span>
        </div>
      </div>
    </div>
  );
};

export default ModuleEndPanel;
